// Package imports:
import React, { Fragment } from 'react';
import cx from 'classnames';
// Component imports:
import useScrollSpy from './UseScrollSpy';

interface IProps {
    parentClass: string
    initialStep?: string,
    children: any,
    containerClass: string,
    navClass: string,
    grouped?: boolean,
    autoIndexing?: boolean
};

const ScrollSpy: React.FC<IProps> = ({
    parentClass,
    initialStep = 'section-1',
    children,
    containerClass = '',
    navClass = '',
    grouped = false,
    autoIndexing = true
}) => {
    const { currentSection, scrollToSection } = useScrollSpy(initialStep, parentClass, 50);

    const goToSection = ((event: any, htmlElement: any) => {
        event.preventDefault();

        scrollToSection(htmlElement)
    })
    return (
        <Fragment>
            <div className={cx('scroll-spy-nav', navClass)}>
                <ul className={cx({ 'auto-indexing': autoIndexing })}>
                    {children && children.map((child: any) => {
                        if (child.props.className === "navGrouper") {
                            return (
                                <li className={cx('groupHeader', { 'is-active': currentSection === child.props.id })} key={child.props["data-group-name"]}>
                                    <a
                                        href={`#${child.props.id}`}
                                        onClick={ev => goToSection(ev, child.props.id)}
                                    >
                                        {child.props.label}
                                    </a>

                                </li>
                            )
                        }
                        return (
                            <li
                                key={child.props.label}
                                className={cx({
                                    'grouped': grouped,
                                    'is-active': currentSection === child.props.id,
                                    'auto-indexing': autoIndexing
                                })}
                            >
                                <a
                                    href={`#${child.props.id}`}
                                    onClick={ev => goToSection(ev, child.props.id)}
                                >
                                    {child.props.label}
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <div className={containerClass}>
                {children}
            </div>
        </Fragment>
    );
};

export default ScrollSpy;
